import { Color3, Nullable, PickingInfo, PointerInfo, StandardMaterial, Vector3 } from '@babylonjs/core'

import BabylonTool from '../babylonTool/BabylonTool'
import { BabylonToolConfig } from '../../../../../types'

export class MeshPoints extends BabylonTool {
    public static NAME = 'mesh-points'
    public static readonly MESH_ID = 'meshPoint'
    public static readonly MESH_POINTS_DIAMETER = 0.3
    public static readonly MESH_POINTS_LINE_COLOR = Color3.Black()
    public static readonly MESH_POINTS_LINE_EDGE_WIDTH = 20
    public static readonly MESH_POINTS_DASH_SIZE = 12
    public static readonly MESH_POINTS_DASH_GAP_SIZE = 6
    public static readonly MESH_POINTS_DASH_NUMBER = 40

    protected static readonly MESH_POINTS_HANDLE_MATERIAL_NAME = 'mesh-points-material'
    protected static readonly MESH_POINTS_HANDLE_COLOR = Color3.White()

    protected meshPoints: Vector3[] = []
    public measureHandleMaterial: StandardMaterial

    constructor(config: BabylonToolConfig) {
        super(config)
        this.name = MeshPoints.NAME
        this.measureHandleMaterial = new StandardMaterial(MeshPoints.MESH_POINTS_HANDLE_MATERIAL_NAME, this.scene)
        this.measureHandleMaterial.emissiveColor = MeshPoints.MESH_POINTS_HANDLE_COLOR
        this.measureHandleMaterial.freeze()
        this.registerActivationFunctions([this.onMouseDown])
    }

    /**
     * Predicate function for determining which mesh is clickable used in selection function to determine what
     * meshes are selectable
     * @returns returns the babylonJS picking info or null
     */
    protected pickWithRayPicker = (): Nullable<PickingInfo> =>
        this.scene.pickWithRay(this.createPickingRay(), (mesh) => {
            return mesh.isEnabled()
        })

    protected selectPoint = (_: PointerInfo) => {}

    protected onMouseDown = (): (() => void) => {
        const pointerObserver = this.scene.onPointerObservable.add(this.selectPoint)

        return (): void => {
            this.scene.onPointerObservable.remove(pointerObserver)
        }
    }
}
